import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function EmptyState({ icon = "ri-inbox-line", title, desc, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-4 rounded-lg bg-background-50 border border-dashed border-background-300">
      <span className="w-16 h-16 rounded-full bg-background-100 flex items-center justify-center text-foreground-400 mb-4">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <h3 className="font-heading font-semibold text-lg text-foreground-950">{title}</h3>
      {desc && <p className="mt-2 text-sm text-foreground-500 max-w-sm">{desc}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}